





































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { ProjectTaskData } from "@/api/project/project-task-type-api";
import _ from "lodash";
import { Project } from "@/api/project-api";
import ProjectManagerApi from "@/api/gateways/project-manager-api";
import ProjectWorkerApi from "@/api/gateways/project-worker-api";
import ProjectWorker from "@/entities/project-worker";
import ProjectManager from "@/entities/project-manager";
import { getAllClientStaffs } from "@/api/client-api";

interface UserOption {
  id: string | number;
  name: string;
}

@Component({
  model: {
    prop: "open",
    event: "change"
  }
})
export default class TaskModal extends Vue {
  @Prop({ type: Boolean }) open!: boolean;
  @Prop({ type: Object }) task?: ProjectTaskData | null;
  @Prop({ required: true }) users!: UserOption[];
  @Prop({ type: String, default: () => "" }) date!: string;
  @Prop({ type: String, default: () => "" }) time!: string;
  @Prop({ type: Boolean, default: () => false }) isEdit!: boolean;
  @Prop({ type: Boolean, default: () => false }) isFromTask!: boolean;
  @Prop({ type: String }) textDefault!: string;

  isShowTimepicker: boolean = false;
  taskSaved: boolean = false;
  data: ProjectTaskData = {
    id: "",
    name: "",
    users: [],
    date: "",
    time: "",
    project: "",
    canEditProject: true,
    isOwner: true,
    canEditName: true
  };

  get init(): ProjectTaskData {
    if (this.isFromTask) {
      this.data =
        this.task && this.task.name
          ? _.clone(this.task as ProjectTaskData)
          : {
              id: "",
              name: "",
              users: [],
              date: this.date || "",
              time: this.time || "",
              project: "",
              canEditProject: true,
              isOwner: true,
              canEditName: true
            };
    } else {
      this.data =
        this.task && Object.keys(this.task).length
          ? _.clone(this.task as ProjectTaskData)
          : {
              id: "",
              name: this.textDefault,
              users: [],
              date: this.date || "",
              time: this.time || "",
              project: "",
              canEditProject: true,
              isOwner: true,
              canEditName: true
            };
    }

    return this.data;
  }

  get projects() {
    let projects = this.$store.state.activeProjects;
    if (this.$store.state.user.hasRole) {
      projects = this.$store.state.serviceProjects;
    }

    return projects
      .filter((item: Project) =>
        item.statusProject ? item.statusProject != 12 : !item.closed
      )
      .map((item: Project) => ({
        id: item.projectId,
        name: item.name
      }));
  }

  get userData() {
    return Array.from(
      new Map(this.users.map(item => [item.id, item])).values()
    );
  }

  async loadProjectMembers() {
    this.data.users = [];

    if (!this.data.project && !this.$store.state.user.hasRole)
      return this.$emit("updateUsers", []);
    if (!this.data.project) return this.$emit("updateUsers", true);
    const users: UserOption[] = ([] as unknown) as UserOption[];
    const pm = new ProjectManagerApi(
      this.$store.getters.api,
      ((this.data.project as unknown) as { id: number }).id
    );
    const pw = new ProjectWorkerApi(
      this.$store.getters.api,
      ((this.data.project as unknown) as { id: number }).id
    );
    const resPm = await pm.assigned();
    resPm.forEach((item: ProjectManager) => {
      if (!item.isHiddenInfo) {
        users.push({
          id: item.id,
          name: item.name
        });
      }
    });
    const resPw = await pw.assigned();
    resPw.forEach((item: ProjectWorker) => {
      if (!item.isHiddenInfo) {
        users.push({
          id: item.id,
          name: item.name
        });
      }
    });

    const clientStaffList = ((await getAllClientStaffs(
      ((this.data.project as unknown) as { id: string }).id
    )) as unknown) as {
      staffId: string | number;
      name: string;
      isHiddenInfo: boolean;
    }[];
    clientStaffList.forEach(item => {
      if (!item.isHiddenInfo) {
        users.push({
          id: item.staffId,
          name: item.name
        });
      }
    });

    this.$emit("updateUsers", users);
  }

  async handleSaveTask() {
    if (this.isFromTask && !this.data.name)
      return this.$refs.name && (this.$refs.name as HTMLElement).focus();
    if (
      this.isFromTask &&
      !this.data.project &&
      !this.$store.state.user.hasRole
    )
      return (
        this.$refs.selectProject && (this.$refs.selectProject as any).activate()
      );
    if (
      this.isFromTask &&
      this.data.users &&
      !this.data.users.length &&
      this.data.canEditProject
    )
      return this.$refs.selectUser && (this.$refs.selectUser as any).activate();

    this.taskSaved = !this.isFromTask;
    this.$emit("saveTask", this.data);
  }

  resetTimepicker() {
    if (!this.task) {
      return (this.data.time = "");
    }

    this.data.time = this.time;
  }

  showAlertIfCanNotEdit(task: ProjectTaskData, type = "name") {
    if (
      (type == "project" && task.canEditProject) ||
      (type == "name" && task.canEditName)
    )
      return;

    alert("編集できません。");
  }

  handleCloseModal() {
    this.$emit("change", false);
    this.$emit("updateUsers", true);
    this.$emit("close");
    this.data =
      this.task && this.task.name
        ? _.clone(this.task as ProjectTaskData)
        : {
            id: "",
            name: "",
            users: [],
            date: this.date || "",
            time: this.time || "",
            project: "",
            canEditProject: true,
            isOwner: true,
            canEditName: true
          };
  }
}
